<template>
	<div class="detail">
		<!-- <h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">常见问题 </h2> -->
		<science-edit v-if='isEdit' :close="handleClose" :form="itemForm" :id="reviseId" ></science-edit>
	</div>
</template>

<script>
import { getFaqList } from '@/utils/axios.js';	
import ScienceEdit from '@/components/ScienceEdit';
	
export default {
	name: 'mainScienceDetail',
	components: {
		ScienceEdit
	},
	data() {
		return {
			submiting: false, // 正在请求
			list: [], //列表
			pageData: {
				count: 0, // 总条数
				page: 1, // 当前页
				pagecount: 0, // 总页数
				pagesize: 15 // 每页条数
			},
			itemForm: {
				title: '',
				content: '',
				sort: 100,
				status: '1'
			},
			isEdit: true,
			reviseId: '', //当前选中Id
		};
	},
	created() {
		
	},
	mounted() {
		if(this.$route.query.id) {
			this.reviseId = this.$route.query.id
			this.handleReviseRemark(this.$route.query.id)
		}
	},
	watch: {},
	methods: {
		// 新增文章
		handleAddArticle() {
			this.reviseId = '',
			this.itemForm = {
				title: '',
				content: '',
				sort: 100,
				status: '1'
			};
		},
		// 关闭文章编辑并重置表单
		handleClose() {
			this.id = '';
			this.itemForm = {
				title: '',
				content: '',
				sort: 100,
				status: '1'
			};
		},
		
		//获取单条文章信息
		handleReviseRemark(id) {
			this.reviseId = id;
			getFaqList({
				act: 'detail',
				id: id
			}).then((res) => {
				if(res.code == 200) {
					this.itemForm = res.data
				}
			})
		},
		// 列表切换
		pageChange(page) {
			this.pageData.page = page;
		}
	}
};
</script>

<style>
	.detail {
		padding: 28px 24px;
	}
</style>
